import styled from 'styled-components';
import { Button } from '../../components/uielements';

export const ResponsiveButton = styled(Button)`
  position: relative;
  background-color: ${({ disabled, theme }) => (disabled ? '#ccc' : theme.palette.color[0])};
  color: ${({ disabled, theme }) => (disabled ? '#666' : theme.palette.text[0])};
  padding: ${({ theme }) => theme.sizes.gap.small} ${({ theme }) => theme.sizes.gap.normal};
  border: none;
  border-radius: ${({ theme }) => theme.sizes.borderRadius.small};
  cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
  font-size: ${({ theme }) => theme.sizes.font.medium};
  transition: background-color 0.3s ease;

  @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
    width: 100%;
    max-width: 100% !important;
  }
`;
